<header-bar title="Videos"></header-bar>
<div class="page-content">

    <div class="card" style="background-color: transparent!important;margin-bottom: 0; margin-top: 0;">
        <div class="content" style="margin-bottom: 6px; margin-top: 0">


            <h2 class="text-white text-left text-uppercase mt-4 mb-4">
                <%= title ? title : '' %>
            </h2>

            <% if ( videos && videos.length > 0  ) {    %>

            <% for ( let vi = 0; vi < videos.length; vi++ )     { %>
                <div class="embed-responsive embed-responsive-16by9 mb-4">
                    <iframe class="embed-responsive-item"
                            style="max-width: 100%"
                            width="<%= videos[ vi ].hasOwnProperty( 'width' ) ? videos[ vi ].width : '560' %>"
                            height="<%= videos[ vi ].hasOwnProperty( 'height' ) ? videos[ vi ].height : '315' %>"
                            src="<%= videos[ vi ].hasOwnProperty( 'src' ) ? videos[ vi ].src : '' %>"
                            title="<%= videos[ vi ].hasOwnProperty( 'title' ) ? videos[ vi ].hasOwnProperty.title : 'YouTube player' %>"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                </div>

            <% }    %>

            <% } else { %>
                <p class="font-weight-bolder text-white">
                    Derzeit sind leider keine Videos in dieser Kategorie verfügbar.
                </p>
            <% }    %>


            <!--
            <iframe title="vimeo-player" src="https://player.vimeo.com/video/901543162?h=f7455f5a24"
                    style="max-width: 100%"
                    width="640" height="360"
                    frameborder="0"
                    allowfullscreen></iframe>
-->
        </div>
    </div>

</div>
<main-menu active-item="videos"></main-menu>
